import { decodeEntities } from "./html-entities.ts";

// Liquid's `escape` filter HTML-encodes `"` chars in property values when the cart drawer
// renders `data-properties`. For free-text values that's transparent (the browser decodes
// the attribute on read), but `_personalization` carries nested JSON whose inner quotes
// arrive as `&quot;` after JSON.parse. Decode that one value here so we re-submit it cleanly
// rather than baking another escape layer in on every cart edit. Other property values are
// left as-is so any literal entity text a shopper typed (e.g. `&quot;` in a note) survives.
function normalizeValue(key: string, value: string): string {
  return key === "_personalization" ? decodeEntities(value) : value;
}

export function parseLineItemProperties(raw: unknown): Record<string, string> | null {
  if (!Array.isArray(raw)) {
    if (typeof raw === "object" && raw !== null) {
      const result: Record<string, string> = {};
      for (const [k, v] of Object.entries(raw)) {
        if (typeof v === "string" && v !== "") result[k] = normalizeValue(k, v);
      }
      return result;
    }
    return null;
  }
  const result: Record<string, string> = {};
  for (const entry of raw) {
    // Shopify retains properties with empty string values rather than removing them,
    // so treat empty strings as absent.
    if (
      Array.isArray(entry) &&
      typeof entry[0] === "string" &&
      typeof entry[1] === "string" &&
      entry[1] !== ""
    ) {
      result[entry[0]] = normalizeValue(entry[0], entry[1]);
    }
  }
  return result;
}
